import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGatewayResponse } from '@/Module/Core/Model/ApiModel';
import type { ISubscriptionPlan } from '@/Module/Subscription/Model/DataModel';
import SubscriptionService from '@/Module/Subscription/Service/SubscriptionService';

export const getSubscriptionPlanListAction = createAsyncThunk<IGatewayResponse<ISubscriptionPlan[]>>(
  'subscription/getListPlan',
  async (_, { signal }) => {
    return SubscriptionService.getPenalList(
      {
        pageNo: 0,
        pageCount: 12,
      },
      signal,
    ).then(({ data }) => data);
  },
);
